export enum Roles {
    Admin = "STD_GLOBAL_ADMIN",
    User = "STD_USER",
    Leader = "STD_LEADER"
}
const AllRole = () => {
    return [Roles.Admin,Roles.User,Roles.Leader];
}
export default AllRole;
